import * as React from 'react';

import { cn } from '@/lib/utils';

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<'input'>>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          'flex h-10 w-full rounded-md border border-sd-input bg-sd-input-bg px-3 py-2 text-base ring-offset-sd-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-sd-foreground placeholder:text-sd-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sd-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = 'Input';

export { Input };
